import apiClient from './apiClient';

export async function fetchDetectionRules() {
  const { data } = await apiClient.get('/threats/rules');
  return data;
}

export async function createDetectionRule(payload) {
  const { data } = await apiClient.post('/threats/rules', payload);
  return data;
}

export async function publishDetectionRule(id) {
  const { data } = await apiClient.post(`/threats/rules/${id}/publish`);
  return data;
}

export async function disableDetectionRule(id) {
  const { data } = await apiClient.post(`/threats/rules/${id}/disable`);
  return data;
}

export async function testDetectionRule(id, payload) {
  const { data } = await apiClient.post(`/threats/rules/${id}/test`, payload);
  return data;
}

export async function fetchSuppressions() {
  const { data } = await apiClient.get('/threats/suppressions');
  return data;
}

export async function createSuppression(payload) {
  const { data } = await apiClient.post('/threats/suppressions', payload);
  return data;
}

export async function runThreatHunt(payload) {
  const { data } = await apiClient.post('/threats/hunt', payload);
  return data;
}

export async function simulateSecurityEvent(payload) {
  const { data } = await apiClient.post('/threats/simulate-event', payload);
  return data;
}
